import { render, staticRenderFns } from "./MaterialType.vue?vue&type=template&id=5bf8e2ed&scoped=true&"
import script from "./MaterialType.vue?vue&type=script&lang=js&"
export * from "./MaterialType.vue?vue&type=script&lang=js&"
import style0 from "./MaterialType.vue?vue&type=style&index=0&id=5bf8e2ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8e2ed",
  null
  
)

export default component.exports